export const TAB_CHANGE_SUBJECT = 'tabChange'
